<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click="$emit('update:expanded', !expanded)">
                    RUNNING
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <ApplicationMenu :collapsed="collapsed" />
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
const ApplicationMenu = () => import('@/modules/snapshot/components/TheApplicationSidebarMenu.vue')

export default {
    name: 'DrawerRunningApplicationsSection',
    components: {
        ApplicationMenu
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    }
}
</script>
